import { reduce } from "et3-type-guards";

import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Section from "../../../../../core/et3-section";
import UserAddComments from "./UserAddComments";
import UserCommentsTable from "./UserCommentsTable";
import { COMMENTS_BOX_GAP } from "./comments-box-constants";
import { ADVANCED_SECTION_IDS } from "../user-advanced-data-constants";

const UserCommentsBox = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const userId = getUserAdvancedStore().currentUserId.get();
  const commentsNumber = reduce(
    () => getUserAdvancedStore().userData.get(userId).commentsNumber,
    0
  );

  return isAnyKhattabaAdmin ? null : (
    <Et3Section
      titleKey={"COMMENTS"}
      summary={""}
      count={commentsNumber}
      sectionId={ADVANCED_SECTION_IDS.COMMENTS}
      defaultOpen={true}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="column"
        alignItems="stretch"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ width: "100%", gap: COMMENTS_BOX_GAP * unitY }}
        onClick={() => {}}
      >
        <UserAddComments />
        <UserCommentsTable />
      </ET3Div>
    </Et3Section>
  );
});
export default UserCommentsBox;
